export enum SortOrder {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}

export enum SortFilter {
  Date = 'SortFilter.Date',
  Rank = 'SortFilter.Rank',
  Score = 'SortFilter.Score',
  Tournament = 'SortFilter.Tournament',
  TotalWin = 'SortFilter.TotalWin',
}

export interface Sorting {
  order: SortOrder
  filter: SortFilter
}
